export default __webpack_public_path__ + "static/media/1115.bdcf345e.png";